<ng-template #templateButton>
  <button [ngClass]="['tab', 'tab-' + size]" [disabled]="disabled" [class.active]="active" (click)="select.emit()">
    <span class="tab-label">{{ label }}</span>
    <span *ngIf="counter" class="tab-label">({{ counter }})</span>
  </button>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
